module.exports = __webpack_public_path__ + "static/img/lj_05.020f229.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lj_05.jpg
// module id = mFuc
// module chunks = 1